import { PortalType } from "@studyportals/domain-client";
import { ROUTE_PREFIX } from '@generator/config/route-prefix';

// Base paths for each portal type, prefixed based on runtime env
export const portalTypeBasePaths: Record<string, string> = {
	[PortalType.MASTER]: `${ROUTE_PREFIX}/search/master`,
	[PortalType.BACHELOR]: `${ROUTE_PREFIX}/search/bachelor`,
	[PortalType.PHD]: `${ROUTE_PREFIX}/search/phd`,
	[PortalType.DISTANCE_LEARNING]: `${ROUTE_PREFIX}/search/distance-learning`,
	[PortalType.SHORT]: `${ROUTE_PREFIX}/search/course`
}